import { useTheme } from '../context/ThemeContext';

const themes = ['light', 'dark', 'system'] as const;

export default function ThemeToggle() {
  const { theme, setTheme } = useTheme();

  const cycle = () => {
    const idx = themes.indexOf(theme);
    setTheme(themes[(idx + 1) % themes.length]);
  };

  return (
    <button
      type="button"
      onClick={cycle}
      aria-label={`Current theme: ${theme}. Click to cycle.`}
      className="p-2 rounded-lg text-gray-600 hover:bg-gray-100 hover:text-gray-900 dark:text-gray-400 dark:hover:bg-gray-800 dark:hover:text-white transition-colors"
    >
      {theme === 'light' && (
        <span aria-hidden>☀️</span>
      )}
      {theme === 'dark' && (
        <span aria-hidden>🌙</span>
      )}
      {theme === 'system' && (
        <span aria-hidden>🖥️</span>
      )}
      <span className="sr-only">{theme}</span>
    </button>
  );
}
